import { render, staticRenderFns } from "./PyramidLevelsOverview.vue?vue&type=template&id=7bbf8614&"
import script from "./PyramidLevelsOverview.vue?vue&type=script&lang=js&"
export * from "./PyramidLevelsOverview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports